import React, { useState } from "react";
import { SKIN_THEMES } from "./constants";

const IcoChevron = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="var(--text-muted)" strokeWidth="2.5" strokeLinecap="round">
    <polyline points="6 9 12 15 18 9"/>
  </svg>
);
const IcoMail = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="var(--text-muted)" strokeWidth="2" strokeLinecap="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);
const IcoPhone = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="var(--text-muted)" strokeWidth="2" strokeLinecap="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.18 2 2 0 0 1 3.59 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.56a16 16 0 0 0 6.29 6.29l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
);
const IcoPin = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="var(--text-muted)" strokeWidth="2" strokeLinecap="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);
const IcoMenu = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
    <line x1="3" y1="6" x2="21" y2="6"/>
    <line x1="3" y1="12" x2="21" y2="12"/>
    <line x1="3" y1="18" x2="21" y2="18"/>
  </svg>
);
const IcoLogout = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--red)" strokeWidth="2.5" strokeLinecap="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
    <polyline points="16 17 21 12 16 7"/>
    <line x1="21" y1="12" x2="9" y2="12"/>
  </svg>
);

export default function Header({ skin, skinId, onSkinChange, dashboardData = {}, onLogout, setSidebarOpen }) {
  const [profileOpen, setProfileOpen] = useState(false);

  const companyName = dashboardData?.company_name || "Admin";
  const initials = companyName.split(" ").slice(0, 2).map((w) => w[0]).join("").toUpperCase();

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

        .hdr-root {
          position: sticky; top: 0; z-index: 50;
          height: 60px;
          display: flex; align-items: center; justify-content: space-between;
          padding: 0 28px;
          background: var(--card-bg);
          border-bottom: 1px solid var(--card-border);
          box-shadow: 0 2px 16px rgba(0,0,0,0.15);
          font-family: 'Inter', system-ui, sans-serif;
        }

        .hdr-left { display: flex; align-items: center; gap: 12px; }

        .hdr-hamburger {
          display: none; align-items: center; justify-content: center;
          width: 36px; height: 36px; border-radius: 10px;
          background: var(--accent-faint);
          border: 1px solid var(--accent-border);
          color: var(--accent);
          cursor: pointer; outline: none;
        }
        @media(max-width:1024px){ .hdr-hamburger{ display:flex; } }

        .hdr-rule { width: 3px; height: 28px; border-radius: 3px; background: var(--accent); flex-shrink: 0; }
        .hdr-title { font-size: 15px; font-weight: 800; color: var(--text-primary); letter-spacing: -0.02em; margin: 0; line-height: 1.2; }
        .hdr-sub { font-size: 11px; color: var(--text-muted); margin: 2px 0 0; font-weight: 400; }

        .hdr-right { display: flex; align-items: center; gap: 16px; }

        .hdr-theme { display: flex; align-items: center; gap: 8px; }
        .hdr-theme-label { font-size: 11px; font-weight: 600; letter-spacing: 0.08em; text-transform: uppercase; color: var(--text-faint); }
        @media(max-width:640px){ .hdr-theme-label{ display:none; } }

        .hdr-dot { border-radius: 50%; border: 2px solid transparent; cursor: pointer; transition: transform 0.15s, box-shadow 0.15s; outline: none; }
        .hdr-dot:hover { transform: scale(1.15); }
        .hdr-dot-active { border-color: var(--text-primary) !important; box-shadow: 0 0 0 2px var(--accent-glow); }

        .hdr-divider { width: 1px; height: 24px; background: var(--surface-border); }

        .hdr-profile-btn {
          display: flex; align-items: center; gap: 10px;
          padding: 5px 10px 5px 5px; border-radius: 12px;
          background: none; border: 1px solid var(--surface-border);
          cursor: pointer; transition: background 0.15s, border-color 0.15s;
        }
        .hdr-profile-btn:hover { background: var(--accent-faint); border-color: var(--accent-border); }

        .hdr-avatar {
          width: 32px; height: 32px; border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          font-size: 13px; font-weight: 700; color: var(--btn-text);
          background: var(--btn-bg);
          box-shadow: 0 0 0 2px var(--accent-glow);
          flex-shrink: 0;
        }
        .hdr-profile-name { font-size: 13px; font-weight: 700; color: var(--text-primary); margin: 0; white-space: nowrap; }
        .hdr-profile-role { font-size: 10.5px; color: var(--text-muted); margin: 1px 0 0; font-weight: 500; }
        @media(max-width:640px){ .hdr-profile-name, .hdr-profile-role, .hdr-chevron{ display:none; } }

        .hdr-dropdown {
          position: absolute; right: 0; top: calc(100% + 8px); width: 272px;
          background: var(--card-bg); border: 1px solid var(--card-border);
          border-radius: 16px; overflow: hidden;
          box-shadow: 0 16px 48px rgba(0,0,0,0.25);
          z-index: 200;
        }

        .hdr-dd-header { display: flex; align-items: center; gap: 12px; padding: 16px; border-bottom: 1px solid var(--card-border); background: var(--surface); }
        .hdr-dd-avatar {
          width: 40px; height: 40px; border-radius: 50%;
          background: var(--btn-bg); color: var(--btn-text);
          display: flex; align-items: center; justify-content: center;
          font-size: 15px; font-weight: 700; flex-shrink: 0;
          box-shadow: 0 0 0 3px var(--accent-glow);
        }
        .hdr-dd-name { font-size: 14px; font-weight: 700; color: var(--text-primary); margin: 0 0 2px; }
        .hdr-dd-role { font-size: 11px; color: var(--accent); font-weight: 600; margin: 0; letter-spacing: 0.06em; text-transform: uppercase; }

        .hdr-dd-body { padding: 12px 16px; }
        .hdr-dd-row { margin-bottom: 10px; }
        .hdr-dd-row:last-child { margin-bottom: 0; }
        .hdr-dd-label { display: flex; align-items: center; gap: 5px; font-size: 10px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: var(--text-faint); margin: 0 0 3px; }
        .hdr-dd-val { font-size: 13px; color: var(--text-sub); margin: 0; word-break: break-word; }

        .hdr-dd-logout {
          width: 100%; display: flex; align-items: center; gap: 8px;
          padding: 12px 16px; border: none; border-top: 1px solid var(--card-border);
          background: transparent; cursor: pointer;
          font-size: 13px; font-weight: 600; color: var(--red);
          transition: background 0.15s; text-align: left;
        }
        .hdr-dd-logout:hover { background: var(--red-faint); }
      `}</style>

      <header className="hdr-root">
        <div className="hdr-left">
          <button className="hdr-hamburger" onClick={() => setSidebarOpen(true)} aria-label="Open menu">
            <IcoMenu />
          </button>
          <div className="hdr-rule" />
          <div>
            <p className="hdr-title">Admin Dashboard</p>
            <p className="hdr-sub">Eblackdog Patrol Management</p>
          </div>
        </div>

        <div className="hdr-right">
          <div className="hdr-theme">
            <span className="hdr-theme-label">Theme</span>
            {SKIN_THEMES.map((s) => (
              <button
                key={s.id}
                title={s.label}
                onClick={() => onSkinChange(s.id)}
                className={`hdr-dot ${skinId === s.id ? "hdr-dot-active" : ""}`}
                style={{
                  width: skinId === s.id ? 18 : 14,
                  height: skinId === s.id ? 18 : 14,
                  background: s.accent,
                  // give light "snow" swatch a visible ring since white-on-white is invisible
                  boxShadow: s.id === "snow" ? "inset 0 0 0 1px #D1D5DB" : "none",
                }}
              />
            ))}
          </div>

          <div className="hdr-divider" />

          <div style={{ position: "relative" }}>
            <button className="hdr-profile-btn" onClick={() => setProfileOpen((o) => !o)}>
              <div className="hdr-avatar">{initials}</div>
              <div>
                <p className="hdr-profile-name">{companyName}</p>
                <p className="hdr-profile-role">Administrator</p>
              </div>
              <span className="hdr-chevron"><IcoChevron /></span>
            </button>

            {profileOpen && (
              <div className="hdr-dropdown">
                <div className="hdr-dd-header">
                  <div className="hdr-dd-avatar">{initials}</div>
                  <div>
                    <p className="hdr-dd-name">{companyName}</p>
                    <p className="hdr-dd-role">Administrator</p>
                  </div>
                </div>

                <div className="hdr-dd-body">
                  {[
                    { label: "Email",   icon: <IcoMail />,  val: dashboardData?.admin_email },
                    { label: "Phone",   icon: <IcoPhone />, val: dashboardData?.company_phone },
                    { label: "Address", icon: <IcoPin />,   val: dashboardData?.company_address },
                  ].map(({ label, icon, val }) => (
                    <div className="hdr-dd-row" key={label}>
                      <p className="hdr-dd-label">{icon}{label}</p>
                      <p className="hdr-dd-val">{val || "—"}</p>
                    </div>
                  ))}
                </div>

                <button className="hdr-dd-logout" onClick={onLogout}>
                  <IcoLogout />
                  Sign out
                </button>
              </div>
            )}
          </div>
        </div>
      </header>
    </>
  );
}